import { useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';

export const useChannelPostComments = (cid: string, id: number) => {
  return useQuery({
    queryKey: ['channel_posts', id, 'comments'],
    queryFn: () => _a.channelPostComments(cid, id),
  });
};
